// NOTE this is type of messages that come from the websockets
// onmessage (msg) => msg.data.type

export const WEBSOCKET_CALL_COPILOT_EVENT_TYPES = {
  CALL_COPILOT_START_LISTENING: "dialer_copilot", //Start listen to the call
  CALL_COPILOT_MESSAGE_COMPETITOR: "competitor_copilot",
  CALL_COPILOT_MESSAGE_OBJECTION: "objection_copilot",
} as const;
